import { useState, useEffect } from 'react'
import {
  BottomNavigation,
  BottomNavigationAction,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Box,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

const drawerWidth = 240

export default function ResponsiveNav({ routes }) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [value, setValue] = useState(pathname)

  useEffect(() => {
    navigate(value)
    // eslint-disable-next-line
  }, [value])

  useEffect(() => {
    setValue(pathname)
  }, [pathname])
  return (
    <>
      <Box
        component='nav'
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: { md: drawerWidth },
          flexShrink: { md: 0 },
        }}
        aria-label='sidebar'
      >
        <List>
          {routes.map(({ label, icon, to }) => (
            <ListItemButton key={to} onClick={() => setValue(to)}>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          ))}
        </List>
      </Box>
      <Paper
        sx={{
          zIndex: 10,
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          display: { md: 'none' },
        }}
        elevation={3}
      >
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue)
          }}
          sx={{ overflowX: 'auto' }}
        >
          {routes.map(({ label, icon, to }) => (
            <BottomNavigationAction
              label={label}
              icon={icon}
              value={to || label}
              key={to || label}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </>
  )
}
